import { GuideBreadcrumbs } from '@/components/GuideBreadcrumbs';
import { GuideTopNavigation } from '@/components/GuideTopNavigation';

export const GuideHeaderBlock = ({
  title,
  currentPath,
  kicker = 'Gibraltar Wedding Guide',
  testIdPrefix = 'guide-header-block',
  h1TestId,
}) => {
  return (
    <header className="space-y-5" data-testid={`${testIdPrefix}-header`}>
      <p className="caption text-[#8f6b00]" data-testid={`${testIdPrefix}-kicker`}>
        {kicker}
      </p>

      <h1 className="heading-xl" data-testid={h1TestId || `${testIdPrefix}-h1`}>
        {title}
      </h1>

      <GuideBreadcrumbs
        currentTitle={title}
        currentPath={currentPath}
        testIdPrefix={`${testIdPrefix}-breadcrumbs`}
      />

      <div
        className="h-px w-full bg-gradient-to-r from-transparent via-[#D4AF37]/70 to-transparent"
        data-testid={`${testIdPrefix}-divider`}
      />

      <GuideTopNavigation testIdPrefix={`${testIdPrefix}-guide-nav`} />
    </header>
  );
};
